<template>
  <Layout>
    <Content :style="{'padding': '10px'}">
      <Breadcrumb :style="{margin: '5px 0'}">
        <BreadcrumbItem>素材管理 > <b>脚本列表</b></BreadcrumbItem>
      </Breadcrumb>
      <Card>
		  <span class="search_span_width">
			  <span class="search_span_width_part1">标题：</span>
			   <Select
				  v-model="search.id"
				  filterable
				  remote
				  clearable
				  :remote-method="searchTitle"
				  :loading="loading1" style="width: 200px;">
				  <Option v-for="(option, index) in options1" :value="option.id" :key="index">{{option.title}}</Option>
			  </Select>
		  
		    <span class="search_span_width_part1">IP标签：</span>
		  		<Select v-model="search.ip_tag_id" style="width:160px">
		  			<Option v-for="item in iptags" :value="item.id" :key="item.id">{{ item.tag_name }}</Option>
		  		</Select>
			<span class="search_span_width_part1">分类：</span>
				<Select v-model="search.tag_id" style="width:160px">
					<Option v-for="item in tags" :value="item.id" :key="item.id">{{ item.tag_name }}</Option>
				</Select>
			<span class="search_span_width_part1">创建时间：</span>
			  <DatePicker type="daterange" v-model="search.created_at"  format="yyyy/MM/dd" placement="bottom-end" placeholder="选择日期" style="width: 200px"></DatePicker>
		  </span>
		  <Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="getScriptList(1)">搜索</Button>
			&nbsp;&nbsp;<Button type="info" @click="importExcel()">脚本导入</Button>
			&nbsp;&nbsp;<router-link type="info" to="/script/scriptContent" active-class="active">添加脚本</router-link>
        <Card id="tableContent" >
          <Table :columns="tableColumns" :data="script_list"></Table>
		   <Page :total="script_total" :current="current_page" :page-size="20" @on-change="getScriptList" show-elevator />
        </Card>
      </Card>
    </Content>
	<Modal v-model="showmodal" :footer-hide=true title="脚本导入">
	     <Form ref="script" :label-width="80" >
			 <FormItem label="类别" prop="tag_id">
			 <Select v-model="tag_id" style="width:160px">
			 	<Option v-for="item in tags" :value="item.id" :key="item.id">{{ item.tag_name }}</Option>
			 </Select>
			 </FormItem>
				<FormItem label="Excel" prop="file">
				    <Upload action="1" :before-upload="handleUpload" >
						<div>{{file_name}}</div>
				    <Button icon="ios-cloud-upload-outline" >请先选择Excel</Button>
				    </Upload>
				</FormItem> 
	         <FormItem>
	             <Button type="primary" @click="scriptExcel()">提交</Button>
	         </FormItem>
	     </Form>
	 </Modal>
	<Modal v-model="deleteModal">
		<p>确定删除？</p>
		<div slot="footer">
			<Button type="error" size="small" @click="delScript()">删除</Button>
		</div>
		</Modal>
  </Layout>
</template>
<script>
export default {
  data(){
    return {
		showmodal : false,
		file_name:'',
		excel_file:'',
		tag_id:0,
		deleteModal:false,
		script_list:[],
		script_total:0,
		current_page:1,
		script_id:0,
		loading1: true,
		options1: [],
		iptags:[],
		tags:[],
		search:{
			id:0,
			ip_tag_id:0,
			created_at:[]
		},
		tableColumns:[
		{ title: '脚本ID', key: 'id', align: 'center' },
		{ title: '标题', key: 'title', align: 'center' },
		{ title: '素材数量', key: 'mat', align: 'center',
			render: (h, params) => {
				return h("div",params.row.mat.length);
			}
		 },
		 { title: '标签', key: 'tag_name', align: 'center' },
		 { title: 'IP标签', key: 'ip_tag_name', align: 'center' },
		{ title: '操作', key: 'action', align: 'center',
		  render: (h, params) => {
			let btns=[]
			btns.push(
				h('Button', {
				  props: { type: 'warning', size: 'small' },
				  style: { marginRight: '5px', marginBottom: '5px'},
				  on: {
					click: () => {      
						this.$router.push('/script/scriptContent?script_id=' + params.row.id);
					}
				  }
				}, '编辑'),
			);
			btns.push(
				h('Button', {
				  props: { type: 'warning', size: 'small' },
				  style: { marginRight: '5px', marginBottom: '5px'},
				  on: {
					click: () => {    
						this.script_id = params.row.id;
						this.deleteModal = true;
					}
				  }
				}, '删除'),
			);
			return h("div",btns);
		  }
		}
		]
	}
  },
  mounted:function(){
    this.getScriptList(1);
	this.getTagList();
	this.getIpTagList();
  },
  computed:{

  },
  methods:{
	  importExcel(){
		  this.excel_file = '';
		  this.file_name = '';
		  this.tag_id = 0;
		  this.showmodal = true;
	  },
	  handleUpload (file) {
	  	this.excel_file = file;
	  	this.file_name = file.name;
	  	return false;
	  },
	  searchTitle(query){
		  if (query !== '') {
			  clearTimeout(this.timer)
			  this.loading1 = true;
			  var oSelf = this
			  this.timer = setTimeout(function () {
				  oSelf.loading1 = false;
				  oSelf.http.get('/admin/knowledge/scriptSearch',{params:{keyword:query}}).then(response=>{
				    let data=response.data;
				    if(data.code!==0){
				  
				    } else{
				  		oSelf.options1 = data.data.list;
				    }
				  }).catch(()=>{
				    oSelf.$Message.error('网络错误');
				  });
			},1000);
			 
		  } else {
			  this.options1 = [];
		  }
		  
	  },
	delScript(){
		this.http.get('/admin/knowledge/delScript',{params:{script_id:this.script_id}}).then(response=>{
		  let data=response.data;
		  if(data.code!==0){
			alert(data.message);
		  } else{
			this.script_id = 0;
			this.deleteModal = false;
			this.getScriptList(this.current_page);
		  }
		}).catch(()=>{
		  this.$Message.error('网络错误');
		});
	},
	getScriptList(page) {
		this.current_page = page;
		let params = Object.assign(this.search);
		params['page'] = page;
		this.http.get('/admin/knowledge/scriptList',{params:params}).then(response=>{
		  let data=response.data;
		  if(data.code!==0){
			alert(data.message);
		  } else{
			this.script_list = data.data.list;
			this.script_total = data.data.total;
		  }
		}).catch(()=>{
		  this.$Message.error('网络错误');
		});
	},
	updateScript(){
		this.http.post('/admin/knowledge/editScript',{
				  id:this.script.id,
				  title:this.script.title
		}).then(response=>{
		  let data=response.data;
		  if(data.code!==0) {
		    this.$Message.error(data.message);
		    return false;
		  } else{
		    this.$Message.info(data.message);
		    this.showmodal = false;
			this.getScriptList();
		    return true;
		  }
		});
	},
	getIpTagList() {
		this.http.get('/admin/common/tagList',{params:{p_tag_id:29}}).then(response=>{
		  let data=response.data;
		  if(data.code!==0){
			alert(data.message);
		  } else{
			this.iptags = data.data;
		  }
		}).catch(()=>{
		  this.$Message.error('网络错误');
		});
	},
	getTagList() {
		this.http.get('/admin/common/tagList',{params:{p_tag_id:48}}).then(response=>{
		  let data=response.data;
		  if(data.code!==0){
			alert(data.message);
		  } else{
			this.tags = data.data;
		  }
		}).catch(()=>{
		  this.$Message.error('网络错误');
		});
	},
	scriptExcel(){
		if (this.tag_id == 0) {
			this.$Message.error('请选择脚本分类');
			return false;
		}
		if (this.excel_file == '') {
			this.$Message.error('请选择上传的Excel');
			return false;
		}
		let config = {
			headers: {
				'Content-Type': 'multipart/form-data',
				"Authorization":localStorage.getItem('token')
			}}
		var param = new FormData();
		param.append('file',this.excel_file);
		param.append('tag_id',this.tag_id);
		let url = process.env.VUE_APP_APIHOST + '/admin/knowledge/scriptExcel';
		this.$axios.post(url, param, config).then((response) => {
			let data = response.data;
			//console.log(data);
			if(data.code!=0){
				this.$Message.error(data.message);
				return true;
			}
			this.$Message.info("上传成功");
			this.showmodal = false;
			this.getScriptList();
		})
	},
    closeModal(){
		this.script.id = 0;
		this.script.title = '';
		this.showmodal=false;
    }
  }

}
</script>
